<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-contact  has-aside-base">
            <Historico :nmComponente="'Consulta'" :reload="reload" :seleciona="seleciona" :novo="novo" :id="idConversa"></Historico>

            <div class="tyn-main tyn-content-inner" id="tynMain">
                <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 z-1">
                    <li>
                        <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg><!-- x-lg -->
                        </button>
                    </li>
                </ul>
                <div class="tyn-chat-body m-4 rounded-3" data-simplebar>
                    <div class="container px-0">
                        <template v-if="idConversa == 0">
                            <div class="tyn-qa tyn-qa-bubbly">
                                <!-- ETAPA 0 -->
                                
                                <template v-if="!(utilizacoes && utilizacoes.permiteRealizarPerguntas) && flVerificouUtilizacoes">
                                    <div class="tyn-qa-item" v-if="etapa >= 0">
                                        <div class="tyn-qa-avatar">
                                            <div class="tyn-qa-avatar-wrap">
                                                <div class="tyn-media tyn-size-md" style="background: transparent">
                                                    <img src="assets/images/sollai/avatar.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tyn-qa-message tyn-text-block bg-response">
                                            <p>
                                                Desculpe, parece que você atingiu seu limite de Perguntas do contrato.
                                                Entre em contato com um dos nossos consultores.
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                    <div class="tyn-qa-item" v-if="etapa >= 0">
                                        <template v-if="etapa == 0 || statusPergunta == 'Cancelada'">
                                            <template v-if="flRealizaPergunta">
                                                <div class="tyn-qa-avatar">
                                                    <div class="tyn-qa-avatar-wrap">
                                                        <div class="tyn-media tyn-size-md" style="background: transparent">
                                                            <img src="assets/images/sollai/avatar.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tyn-qa-message tyn-text-block bg-response">
                                                    <p>Como posso ajudá-lo hoje?</p>
                                                </div>

                                            </template>
                                            <template v-else-if="flVerificouRealizar">
                                                <div class="tyn-qa-avatar">
                                                    <div class="tyn-qa-avatar-wrap">
                                                        <div class="tyn-media tyn-size-md" style="background: transparent">
                                                            <img src="assets/images/sollai/avatar.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tyn-qa-message tyn-text-block bg-response">
                                                    <p>
                                                        {{msgNaoRealizaPergunta}}
                                                    </p>
                                                </div>
                                            </template>
                                        </template>
                                    </div>

                                    <!-- ETAPA 1 -->
                                    <!-- LEGISLACAO -->
                                    <template v-if="etapa > 0">
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-media tyn-size-md">
                                                    <template v-if="user.usuarioApi">
                                                        <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                        <img v-else src="assets/images/avatar/3.jpg" alt="">
                                                    </template>
                                                    <template v-else>
                                                        <img src="assets/images/avatar/3.jpg" alt="">
                                                    </template>
                                                </div>
                                            </div>
                                            <template v-if="flReprocessar">
                                                <div class="tyn-qa-message tyn-text-block bg-question">
                                                    <div class="form-group">
                                                        <textarea class="form-control" placeholder="Digite sua pergunta" maxlength="5000" v-model="formPergunta.dsPergunta"></textarea>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="tyn-qa-message tyn-text-block bg-question">{{formPergunta.dsPergunta}}</div>
                                            </template>

                                        </div>

                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p><span class="fw-bold">Escolha a legislação:</span> (Baseado em qual lei deseja a resposta) </p>
                                                <div class="d-flex align-items-center mb-1 ps-3 form-check" v-for="(item,index) in lstLeis" v-bind:key="index">
                                                    <input class="form-check-input" :disabled="!(!disabled && !item.disabled)" type="radio" :id="'option'+ index" name="idLegislacao" :value="item.value" v-model="formPergunta.idLegislacao" />
                                                    <label class="form-check-label ps-2" :for="'option'+index">
                                                        {{index + 1}} - {{item.titulo}}  {{(item.descricao && item.descricao != ""? "- "+item.descricao : "")}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 1">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(1)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 2 -->
                                    <!-- FORMATO RESPOSTA -->
                                    <template v-if="etapa > 1">
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold">Escolha o formato da resposta:</p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstTiposPerguntas" v-bind:key="index">
                                                    <input type="radio" :id="'huey'+ index" name="tpPergunta" :value="item.value" v-model="formPergunta.tpPergunta" :disabled="disabled" />
                                                    <label class="ps-2" :for="'huey'+index">
                                                        {{item.titulo}} {{item.descricao}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 2">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(2)">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- PROCESSANDO -->
                                    <template v-if="etapa > 2">
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                    <p class="fw-bold mb-2">
                                                        {{mensagemProcessando}}
                                                    </p>
                                                    <p class="mb-2">
                                                        Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                    </p>
                                                    <div class="progress px-0">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                    </div>
                                                </template>
                                                <template v-if="statusPergunta == 'Cancelada'">
                                                    <span class="text-danger fs-1">
                                                        <i class="fas fa-exclamation-triangle"></i>
                                                    </span>
                                                    <p class="mb-2">
                                                        Erro ao processar a pergunta
                                                    </p>
                                                    <p class="mb-2">
                                                        {{msgErro}}
                                                    </p>
                                                    <button class="btn-default bg-solid-primary" @click="enviarPergunta" v-if="flReprocessar">
                                                        Reprocessar
                                                    </button>
                                                </template>
                                                <template v-if="statusPergunta == 'Finalizada'">
                                                    <template vif="pergunta">
                                                        <p class="mb-20" style="white-space: pre-line;" :id="'resposta_'+pergunta.idConversa" v-html="pergunta.dsResposta">
                                                        </p>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                        </template>
                        <template v-else>
                            <!-- RESULTADO -->
                            <div class="tyn-qa tyn-qa-bubbly" id="printMe">

                                <div class="tyn-qa-item" v-if="pergunta">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-media tyn-size-md">
                                            <template v-if="user.usuarioApi">
                                                <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                <img v-else src="assets/images/avatar/3.jpg" alt="">
                                            </template>
                                            <template v-else>
                                                <img src="assets/images/avatar/3.jpg" alt="">
                                            </template>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-question">{{pergunta.dsPergunta}}</div>
                                </div>


                                <div class="tyn-qa-item" v-if="etapa >= 0">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <img src="assets/images/sollai/avatar.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response" v-if="pergunta">
                                        <div class="d-flex justify-content-end">
                                            <div class="dropdown" v-if="!flImprimir">
                                                <button class="btn btn-icon btn-light  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                    </svg>
                                                </button>
                                                <ul class="dropdown-menu acoes">
                                                    <li >
                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="imprimir">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                                                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                                                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                                                            </svg> Imprimir
                                                        </a>
                                                    </li>
                                                    <li v-if="statusPergunta == 'Finalizada'">
                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="pdf">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                            </svg> Baixar PDF
                                                        </a>
                                                    </li>
                                                    <li v-if="statusPergunta == 'Finalizada'">
                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="word">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-word" viewBox="0 0 16 16">
                                                                <path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z" />
                                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                            </svg> Baixar Word
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-12 col-md-8" >
                                                <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                    <p class="fw-bold mb-2">
                                                        {{mensagemProcessando}}
                                                    </p>
                                                    <p class="mb-2">
                                                        Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                    </p>
                                                    <div class="progress px-0">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                    </div>
                                                </template>
                                                <template v-if="statusPergunta == 'Cancelada'">
                                                    <span class="text-danger fs-1">
                                                        <i class="fas fa-exclamation-triangle"></i>
                                                    </span>
                                                    <p class="fw-bold mb-2">
                                                        Erro ao processar a pergunta
                                                    </p>
                                                    <p class="mb-2">
                                                        {{msgErro}}
                                                    </p>
                                                </template>
                                                <template v-if="statusPergunta == 'Finalizada'">
                                                    <template v-if="pergunta">
                                                        <div class="mb-2 resposta" style="white-space: pre-line; " :id="'resposta_'+pergunta.idConversa" v-html="pergunta.dsResposta">
                                                        </div>
                                                    </template>
                                                </template>
                                            </div>
                                            <div class="col-12 col-md-4 referencias mt-5 mt-sm-0" v-if="pergunta">
                                                <template v-if="pergunta.usuario">
                                                    <p class="mb-0" v-if="user.usuario.dsLogin != pergunta.usuario.dsLogin">
                                                        <strong>Usuário: </strong>{{pergunta.usuario.nmUsuario}}
                                                    </p>
                                                </template>
                                                <p class="mb-0">
                                                    <strong>Data da solicitação: </strong>{{pergunta.dtPergunta}}
                                                </p>
                                                <p class="mb-2">
                                                    <strong>Formato de resposta: </strong>
                                                    <template v-if="pergunta.tpPergunta == 'Resposta objetiva' || pergunta.tpPergunta == 'RO'">
                                                        Resposta Objetiva
                                                    </template>
                                                    <template v-else>
                                                        Parecer técnico
                                                    </template>
                                                </p>
                                                <p class="mb-2"><strong>Referências utilizadas</strong></p>
                                                <p class="mb-2 resposta" style="white-space: pre-line;" v-if="pergunta.dsReferencias" v-html="pergunta.dsReferencias"></p>
                                                <p class="mb-0" v-if="legislacao">
                                                    <strong>Legislação: </strong>
                                                    <template v-if="legislacao.dsNome == 'Sistema S'">
                                                        <span> {{legislacao.dsNome}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)" v-if="!flImprimir">
                                                            {{legislacao.dsNome}}
                                                        </a>
                                                        <span v-else> {{legislacao.dsNome}}</span>
                                                    </template>
                                                </p>
                                                <p class="mb-0" v-if="norma">
                                                    <strong>Normativa: </strong>
                                                    <a href="javascript:void(0)" @click="download(norma.urlArquivo, norma.dsNome)" v-if="!flImprimir">
                                                        {{norma.dsNome}}
                                                    </a>
                                                    <span v-else> {{norma.dsNome}}</span>
                                                </p>
                                                <p class="mb-0" v-if="pergunta && legislacao">
                                                    <template v-if="pergunta.tpPergunta != 'Resposta objetiva' && pergunta.tpPergunta != 'RO'">
                                                        <p class="mb--0" v-if="lstDoutrinas.find(x=>x.cdLegislacao == legislacao.cdLegislacao)">
                                                            <strong>Doutrina: </strong>
                                                            <br />
                                                            <template v-for="(item,index) in lstDoutrinas.find(x=>x.cdLegislacao == legislacao.cdLegislacao).lstArquivos">
                                                                <div :key="index">
                                                                    <a href="javascript:void(0)" @click="openDoutrina(item.id)" v-if="!flImprimir">
                                                                        {{item.nome}}
                                                                    </a>
                                                                    <span v-else>{{item.nome}}</span>
                                                                    <br />
                                                                </div>

                                                            </template>
                                                        </p>
                                                    </template>
                                                </p>
                                                <template v-if="lstReferencias">
                                                    <div v-if="lstReferencias.lstAcordao.length > 0 || lstReferencias.lstAcordaoStf.length > 0">
                                                        <p class="mb-0"><strong>Acórdão</strong></p>
                                                        <template v-if="lstReferencias.lstAcordao.length > 0">
                                                            <h6>TCU</h6>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstAcordao" :key="index" v-html="item.dsTitulo " @click="openReferencia('ACORD', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                        <template v-if="lstReferencias.lstAcordaoStf.length > 0">
                                                            <P>STF</P>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstAcordaoStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('ACSTF', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                    </div>

                                                    <div v-if="lstReferencias.lstBoletim.length > 0 || lstReferencias.lstBoletimStf.length > 0">
                                                        <p class="mb-0"><strong>BOLETIM</strong></p>
                                                        <template v-if="lstReferencias.lstBoletim.length > 0">
                                                            <p>TCU</p>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstBoletim" :key="index" v-html="item.dsTitulo" @click="openReferencia('BOLET', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                        <template v-if="lstReferencias.lstBoletimStf.length > 0">
                                                            <P>STF</P>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstBoletimStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('BOSTF', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                    </div>

                                                    <div v-if="lstReferencias.lstJurisprudencia.length > 0 || lstReferencias.lstJurisprudenciaStf.length > 0">
                                                        <p class="mb-0"><strong>Jurisprudência</strong></p>
                                                        <template v-if="lstReferencias.lstJurisprudencia.length > 0">
                                                            <p>TCU</p>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstJurisprudencia" :key="index" v-html="item.dsTitulo" @click="openReferencia('JURIS', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                        <template v-if="lstReferencias.lstJurisprudenciaStf.length > 0">
                                                            <P>STF</P>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstJurisprudenciaStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('JUSTF', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                    </div>

                                                    <div v-if="lstReferencias.lstSumula.length > 0 || lstReferencias.lstSumulaStf.length > 0">
                                                        <p class="mb-0"><strong>Súmula</strong></p>
                                                        <template v-if="lstReferencias.lstSumula.length > 0">
                                                            <p>TCU</p>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstSumula" :key="index" v-html="item.dsTitulo" @click="openReferencia('SUMUL', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                        <template v-if="lstReferencias.lstSumulaStf.length > 0">
                                                            <P>STF</P>
                                                            <ul>
                                                                <li class="c-pointer" v-for="(item,index) in lstReferencias.lstSumulaStf" :key="index" v-html="item.dsTitulo" @click="openReferencia('SUSTF', item.idConteudo)"></li>
                                                            </ul>
                                                        </template>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <button class="btn btn-outline-primary" @click="novo">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg> Criar nova consulta
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tyn-chat-form border-0 px-4" v-if="flInputText">
                    <div class="container px-0">
                        <div class="chat-input-modern">
                            <div class="chat-input-wrapper">
                                <div class="form-group-modern w-100">
                                    <textarea 
                                        class="form-control-modern" 
                                        rows="3" 
                                        id="tynBotInput" 
                                        v-model="formPergunta.dsPergunta"
                                        placeholder="Digite sua pergunta aqui..."
                                        maxlength="5000"
                                    ></textarea>
                                    <div class="char-counter" v-if="formPergunta.dsPergunta">
                                        {{ formPergunta.dsPergunta.length }}/5000
                                    </div>
                                </div>
                                <button 
                                    id="tynBotSend" 
                                    type="button" 
                                    @click="proximo(0)" 
                                    class="btn-send-modern"
                                    :disabled="!formPergunta.dsPergunta || formPergunta.dsPergunta.length < 3"
                                >
                                    <i class="fas fa-paper-plane me-2"></i>
                                    <span>Enviar Pergunta</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAIS HEADER -->
        <Modais></Modais>
        

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
        <ModalDoutrina :tipo="tipoDoutrina" :showModal="showModalDoutrina"></ModalDoutrina>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import Historico from '@/components/Historico'
    import ModalDetalhes from '@/components/ModalDetalhes'
    import ModalDoutrina from '@/components/ModalDoutrina'

    
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Consulta',
        components: { Header, Modais, Historico, ModalDetalhes, ModalDoutrina },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
        },
        data: function () {
            return {
                flInputText: true,

                idConversa: 0,
                etapa: 0,

                lstLeis: [],
                lstTiposPerguntas: [],
                lstTiposResposta: [
                    { value: 'RO', titulo: 'Resposta Objetiva', descricao: '- Apresentarei a resposta utilizando a Lei selecionada, fornecendo uma resposta direta e precisa' },
                    { value: 'PJ', titulo: 'Parecer Técnico', descricao: '- Elaborarei a resposta com base na Lei, nas normas correlatas e nas jurisprudências pertinentes, apresentando-a no formato de parecer.' },
                ],
                utilizacoes: null,
                flVerificouUtilizacoes: false,

                formPergunta: {
                    dsPergunta: null,
                    idLegislacao: null,
                    tpPergunta: null,
                    idNorma: null,
                },

                pergunta: null,

                lstReferencias: null,
                legislacao: null,
                norma: null,

                statusPergunta: null,

                timer: 0,
                intervalTimer: null,

                msgErro: null,
                disabled: false,
                flRealizaPergunta: false,
                msgNaoRealizaPergunta: "Aguarde a conclusão da pergunta atual antes de realizar uma nova pergunta",
                mensagemProcessando: "Processando pergunta...",
                flImprimir: false,
                flWord: false,
                flReprocessar: false,
                reload: false,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                showModalDoutrina: false,
                flVerificouRealizar: false,

                tipoDoutrina: 0,
                lstDoutrinas: [
                    {
                        cdLegislacao: 1, lstArquivos: [
                            { id: 0, nome: 'Licitações e Contratos Administrativos na Lei 14.133/21.pdf' },
                            { id: 1, nome: 'Governança das Contratações.pdf' },
                            { id: 2, nome: 'Caderno de Pesquisa de Preços - MGI.pdf' },
                            { id: 3, nome: 'Instrumento de Padronização - AGU.pdf' },
                            { id: 4, nome: 'Instrumento de Padronização de TI - AGU.pdf' },
                            { id: 5, nome: 'Perguntas Frequentes em Contratações - AGU.pdf' },
                            { id: 6, nome: 'Referencial básico gestão riscos.pdf' },
                        ]
                    },
                    {
                        cdLegislacao: 2, lstArquivos: []
                    },
                    {
                        cdLegislacao: 3, lstArquivos: []
                    },
                    {
                        cdLegislacao: 6, lstArquivos: [
                            { id: 7, nome: 'Artigo A Atuação Sistêmica e Sinergia nas Entidades do Sistema S.pdf' },
                            { id: 8, nome: 'Artigo A Autonomia Administrativa das Entidades do Sistema S' },
                            { id: 9, nome: 'artigo Contratos do Sistema S.pdf' },
                            { id: 10, nome: 'Artigo Novos Regulamentos de Contratações do Sistema S.pdf' },
                            { id: 11, nome: 'Artigo Reforma das contratações do Sistema S.pdf' },
                            { id: 12, nome: 'Artigo Regulamento de Contratação das Entidades do Sistema S.pdf' },
                            { id: 13, nome: 'Artigo Retrospectiva Sistema S Princípios da Administração Pública.pdf' },
                            { id: 14, nome: 'Ebook Pesquisa_de_Mercado_no_Sistema_S.pdf' },
                            { id: 15, nome: 'ebook sistema S Boas Praticas.pdf' },
                            { id: 16, nome: 'O TCU e o Sistema S - Portal TCU.pdf' },
                            { id: 17, nome: 'orientacaoSollicita.pdf' },
                            { id: 18, nome: 'Sistema S e Licitações - Portal do TCU.pdf' },
                        ]
                    },
                ],
            }
        },

        methods: {
            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },

            novo() {
                this.idConversa = 0;
                this.etapa = 0;
                this.formPergunta = { dsPergunta: null, idLegislacao: null, tpPergunta: null, idNorma: null };
                this.pergunta = null;
                this.statusPergunta = null;
                this.timer = 0;
                this.intervalTimer = null;
                this.msgErro = null;
                this.disabled = false;
                this.flInputText = true;
                this.flReprocessar = false;

                this.load();
            },

            load() {
                if (this.idConversa != 0) {
                    this.disabled = true;
                    this.flInputText = false;

                    this.carregaConversa();
                }

                this.verificaRealizaPergunta();
                this.carregaUtilizacoes();
                /*this.getLeis();*/
            },

            seleciona(id, tipo) {
                if (tipo == 1) {
                    this.idConversa = id;
                    this.load();
                }
            },

            proximo(index) {
                let $this = this;
                switch (index) {
                    case 0:
                        //$this.formPergunta.dsPergunta = document.getElementById('tynBotInput').innerHTML;
                        if ($this.formPergunta.dsPergunta != '' && $this.formPergunta.dsPergunta != null && $this.formPergunta.dsPergunta.length >= 3) {
                            document.getElementById('tynBotInput').innerHTML = "";
                            
                            $this.flInputText = false;

                            // verifica idLegislacao da Home
                            if ($this.formPergunta.idLegislacao != null) {
                                $this.getTipoPergunta($this.formPergunta.idLegislacao);
                                $this.etapa = 2;
                            } else {
                                $this.etapa = 1;
                            }
                            
                        } else {
                            avisoToast("A pergunta deve conter pelo menos 3 caracteres", "warning");
                        }

                        
                        
                        break;
                    case 1:
                        if ($this.formPergunta.idLegislacao != null) {
                            $this.getTipoPergunta($this.formPergunta.idLegislacao);
                            $this.etapa = 2;
                        } else {
                            avisoToast("Selecione uma legislação", "warning");
                        }      

                        break;

                    case 2:
                        if ($this.formPergunta.tpPergunta != null) {
                            if ($this.utilizacoes && $this.utilizacoes.permiteRealizarPerguntas) {
                                $this.etapa = 3;
                                $this.enviarPergunta();
                            } else {
                                avisoToast("Desculpe, parece que você atingiu seu limite de Perguntas do contrato. Entre em contato com um dos nossos consultores.", "warning");
                            }
                        } else {
                            avisoToast("Selecione um formato de resposta", "warning");
                        }
                        break;

                    default:
                        break;
                }
            },

            enviarPergunta() {
                let $this = this;
                $this.statusPergunta = 'Processando';
                $this.disabled = true;
                $this.iniciaProcessando();

                axios.post(`${urlApi}/Parecer/post`, { dsPergunta: $this.formPergunta.dsPergunta, tpPergunta: $this.formPergunta.tpPergunta, idLegislacao: $this.formPergunta.idLegislacao, idNorma: $this.formPergunta.idNorma }, { showloading: false })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Pergunta registrada com sucesso, acompanhe a situação no campo status da listagem.");
                            $this.reload = !$this.reload;
                            $this.idConversa = parseInt(res.data.msg);
                            $this.load();
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.disabled = false;
                        $this.statusPergunta = 'Cancelada';
                        $this.msgErro = 'Não conseguimos responder sua pergunta';
                        if (res.response.data) {
                            if (res.response.data.msg == 'Nossa ia não identificou esse assunto relacionado com licitações e contratos') {
                                var msg = res.response.data.msg;
                                $this.msgErro = msg;
                                if (res.response.data.errors) {
                                    msg = msg + '. ' + res.response.data.errors[0];
                                }
                                avisoErro(msg);
                            } else {
                                $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);

                                //avisoErro("Não foi possível enviar a pergunta.");
                            }
                        } else {
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    });
            },

            // ----------------
            carregaConversa() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/Get/${$this.idConversa}`)
                    .then(res => {
                        $this.etapa = 4;
                        $this.pergunta = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstConversaMovimento.length > 0) {
                                status = result.lstConversaMovimento[result.lstConversaMovimento.length - 1].dsMovimento;
                                $this.statusPergunta = status;
                            }

                            $this.formPergunta = {
                                dsPergunta: result.conversa.dsPergunta,
                                idLegislacao: result.conversa.idLegislacao,
                                tpPergunta: result.conversa.tpPergunta,
                            };
                            $this.pergunta = {
                                idConversa: result.conversa.idConversa,
                                dsPergunta: result.conversa.dsPergunta,
                                dsResposta: (result.conversa.dsResposta != null ? result.conversa.dsResposta.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                                tpPergunta: result.conversa.tpPergunta,
                                dsLogin: result.conversa.dsLogin,
                                status: status,
                                usuario: result.usuario,
                                dtPergunta: moment(result.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                idLegislacao: result.conversa.idLegislacao,
                                dsReferencias: (result.conversa.dsReferencias != null ? result.conversa.dsReferencias.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                                idNorma: result.conversa.idNorma,
                            };
                            $this.getConversaReferencias();

                            if (result.conversa.idLegislacao) {
                                $this.getLegislacao(result.conversa.idLegislacao);
                            }

                            if ($this.pergunta.idNorma) {
                                $this.getNorma($this.pergunta.idNorma);
                            } else {
                                $this.norma = null;
                            }

                        } else {
                            avisoErro("Não foi possível carregar a pergunta.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        $this.loading.hide();
                    });
            },

            getConversaReferencias() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/GetConversaReferencias/${$this.idConversa}`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            let result = res.data.data;
                            $this.lstReferencias = {
                                lstAcordao: [],
                                lstAcordaoStf: [],
                                lstBoletim: [],
                                lstBoletimStf: [],
                                lstJurisprudencia: [],
                                lstJurisprudenciaStf: [],
                                lstSumula: [],
                                lstSumulaStf: [],
                            };
                            for (let i = 0; i < result.length; i++) {
                                let item = result[i];
                                switch (item.tpConteudo) {
                                    case "ACORD":
                                        $this.lstReferencias.lstAcordao.push(item);
                                        break;
                                    case "ACORDSTF":
                                        $this.lstReferencias.lstAcordaoStf.push(item);
                                        break;

                                    case "BOLET":
                                        $this.lstReferencias.lstBoletim.push(item);
                                        break;
                                    case "BOLETSTF":
                                        $this.lstReferencias.lstBoletimStf.push(item);
                                        break;

                                    case "JURIS":
                                        $this.lstReferencias.lstJurisprudencia.push(item);
                                        break;
                                    case "JURISSTF":
                                        $this.lstReferencias.lstJurisprudenciaStf.push(item);
                                        break;

                                    case "SUMUL":
                                        $this.lstReferencias.lstSumula.push(item);
                                        break;
                                    case "SUMULSTF":
                                        $this.lstReferencias.lstSumulaStf.push(item);
                                        break;
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar as referencias.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },
            getLegislacao(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get/${idLegislacao}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacao = result;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },
            getNorma(idNorma) {
                let $this = this;
                axios.get(`${urlApi}/Norma/Get/${idNorma}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.norma = result;
                            if ($this.norma.nmNorma) {
                                $this.norma.dsNome = $this.norma.nmNorma;
                            } else if ($this.norma.nmArquivo == null || $this.norma.nmArquivo == "") {
                                var nomeArquivo = $this.norma.urlArquivo.split('/');
                                if (nomeArquivo.length > 0) {
                                    //item.dsNome = nomeArquivo[nomeArquivo.length - 1].slice(7);
                                    $this.norma.dsNome = nomeArquivo[nomeArquivo.length - 1];
                                }
                            } else {
                                $this.norma.dsNome = $this.norma.nmArquivo;
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            iniciaProcessando: function () {
                let $this = this;
                if (this.statusPergunta == 'Processando') {
                    var flag = true;
                    $this.timer = 0;

                    if (flag) {
                        flag = false;
                        $this.intervalTimer = setInterval(function () {
                            if ($this.timer < 100) {
                                $this.timer = $this.timer + 1;
                            } else {
                                flag = true;
                                clearInterval($this.intervalTimer);
                            }
                        }, 3000);
                    }
                } else {
                    if ($this.intervalTimer && $this.intervalTimer != null) {
                        clearInterval($this.intervalTimer);
                    }
                }
            },

            verificaRealizaPergunta() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/VerificaRealizarPergunta`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaPergunta = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },
            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            $this.getLeis();
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                        $this.loading.hide();
                    });
            },
            getLeis() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLeis = [];
                            for (let i = 0; i < res.data.data.length; i++) {
                                var item = res.data.data[i];

                                if ($this.utilizacoes && $this.utilizacoes.lstLegislacoes) {
                                    if ($this.utilizacoes.lstLegislacoes.find(x => x == item.idLegislacao)) {
                                        $this.lstLeis.push({ value: item.idLegislacao, titulo: item.dsNome, descricao: item.dsLegislacao, disabled: false });
                                    } else {
                                        $this.lstLeis.push({ value: item.idLegislacao, titulo: item.dsNome, descricao: item.dsLegislacao, disabled: true });
                                    }
                                }
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },
            getTipoPergunta(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/TipoPergunta/Get`, { showLoading: false, params: { idLegislacao: idLegislacao } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTiposPerguntas = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                $this.lstTiposPerguntas.push({ value: item.cdTipoPergunta, titulo: item.dsNome, descricao: item.dsTipoPergunta, });
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    //var token = $this.user.accessToken;
                    //var connection = new window.signalR.HubConnectionBuilder().withUrl(`${urlSignal}notificacaohub?p_dsLogin=` + $this.user.usuario.dsLogin, { accessTokenFactory: () => token }).build();

                    $this.hubConection.on("RecebeNotificacao", function (idConversa, status, dtAtualizacao) {
                        if ($this.idConversa == idConversa) {
                            $this.load();
                        } else {
                            avisoToast('Status da pergunta atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                        //if ($this.perguntas.findIndex((element) => element.idConversa == idConversa) != -1) {
                        //    $this.perguntas[$this.perguntas.findIndex((element) => element.idConversa == idConversa)].status = status;
                        //    $this.perguntas[$this.perguntas.findIndex((element) => element.idConversa == idConversa)].dtAtualizacao = moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm');
                        //}
                    });

                    $this.hubConection.on("AtualizaRealizarPergunta", function (flRealizaPergunta) {
                        $this.flRealizaPergunta = flRealizaPergunta == "Sim" || flRealizaPergunta == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatus", function (idConversa, status,) {
                        $this.mensagemProcessando = status;
                    });

                    //$this.hubConection.start().then(function () {
                    //    //console.log('Connetado!');
                    //}).catch(function (err) {
                    //    return console.error('Erro: ', err.toString());
                    //});

                    //$this.hubConection.onclose(async () => {
                    //    setTimeout(function () {
                    //        console.log('Tentando Reconectar!');
                    //        $this.hubConection.start();
                    //    }, 5000);
                    //});
                }
                catch (ex) {
                    //console.log(ex);
                }
            },
            
            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            openDoutrina(tipo) {
                this.tipoDoutrina = tipo;
                this.showModalDoutrina = !this.showModalDoutrina;
            },
            imprimir() {
                let $this = this;
                $this.flImprimir = true;
                // Pass the element id here
                $this.$nextTick(function () {
                    $this.print();
                })
            },

            async print() {
                let $this = this;
                await $this.$htmlToPaper('printMe', {
                    styles: [
                        'assets/css/app.css',
                        'assets/css/bundle.css',
                        //'assets/css/plugins/bootstrap.min.css',
                        //'assets/css/plugins/animation.css',
                        //'assets/css/plugins/feature.css',
                        //'assets/css/plugins/magnify.min.css',
                        //'assets/css/plugins/slick.css',
                        //'assets/css/plugins/slick-theme.css',
                        //'assets/css/plugins/lightbox.css',
                        //'assets/css/plugins/bootstrap-select.min.css',
                        //'assets/css/plugins/material-icons/css/materialicons.css',
                        //'assets/css/plugins/prism.css',
                    ],
                }, () => {
                    $this.flImprimir = false;
                });
            },

            word() {
                let $this = this;
                //$this.flImprimir = true;
                //$this.flWord = true;
                //// Pass the element id here
                //$this.$nextTick(function () {
                //    $this.gerarWord3();
                //})

                axios({
                    url: `${urlApi}/Parecer/DownloadWord/${$this.idConversa}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', 'documento.docx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            pdf() {
                let $this = this;
                axios({
                    url: `${urlApi}/Parecer/DownloadPdf/${$this.idConversa}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', 'documento.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },
        },
        mounted: function () {
            this.load();

            if (this.$route.query.idLegislacao != undefined) {
                this.formPergunta.idLegislacao = this.$route.query.idLegislacao;
            }

            // signalR
            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            'formPergunta.idLegislacao': function () {
                this.formPergunta.tpPergunta = null;
                this.formPergunta.idNorma = null;
                this.getTipoPergunta(this.formPergunta.idLegislacao);
            },

            'formPergunta.tpPergunta': function () {
                this.formPergunta.idNorma = null;
                if (this.etapa > 2) {
                    this.etapa = 2;
                }
            },
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-question, .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-question {
        background: var(--qa-bg-human);
    }

    .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-response, .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-response {
        background: var(--qa-bg);
    }

    .bg-response a {
        color: var(--bs-body-color);
    }

        .bg-response a:hover, .bg-response li:hover {
            text-decoration: underline;
            color: var(--bs-body-color);
        }

    .referencias {
        padding-left: 30px;
    }

        .referencias li {
            font-size: 14px;
        }

    .resposta {
        text-align: justify;
    }

    /* ========================================
       ESTILOS MODERNOS PARA INPUT DE PERGUNTAS
       ======================================== */
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }

    .chat-input-modern {
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        backdrop-filter: blur(10px);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 20px;
        padding: 1.5rem;
        margin-bottom: 2rem;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1), 
                    0 4px 12px rgba(31, 123, 255, 0.15);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        animation: fadeInUp 0.5s ease-out;

        &:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15), 
                        0 6px 16px rgba(31, 123, 255, 0.25);
            border-color: rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);
        }

        &:focus-within {
            border-color: #1f7bff;
            box-shadow: 0 15px 45px rgba(31, 123, 255, 0.2), 
                        0 0 0 4px rgba(31, 123, 255, 0.1);
            transform: translateY(-3px);
        }
    }

    .chat-input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .form-group-modern {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .form-control-modern {
        width: 100%;
        padding: 1rem 1.25rem;
        border: 2px solid #e9ecef;
        border-radius: 14px;
        font-size: 1rem;
        line-height: 1.6;
        color: #2d3748;
        background-color: #ffffff;
        resize: vertical;
        min-height: 80px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-family: inherit;

        &::placeholder {
            color: #a0aec0;
            opacity: 1;
        }

        &:hover:not(:focus) {
            border-color: #cbd5e0;
            background-color: #f8f9fa;
        }

        &:focus {
            outline: none;
            border-color: #1f7bff;
            background-color: #ffffff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:disabled {
            background-color: #f1f3f5;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    .char-counter {
        position: absolute;
        bottom: 8px;
        right: 12px;
        font-size: 0.75rem;
        color: #6c757d;
        background: rgba(255, 255, 255, 0.9);
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        font-weight: 500;
        pointer-events: none;
        transition: color 0.3s ease;
    }

    .form-control-modern:focus ~ .char-counter {
        color: #1f7bff;
    }

    .btn-send-modern {
        align-self: flex-end;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.875rem 2rem;
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        color: white;
        border: none;
        border-radius: 14px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
        position: relative;
        overflow: hidden;
        min-width: 180px;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s ease, height 0.6s ease;
        }

        &:hover:not(:disabled)::before {
            width: 300px;
            height: 300px;
        }

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #4a94ff 0%, #00d084 100%);
            box-shadow: 0 10px 30px rgba(31, 123, 255, 0.4),
                        0 0 20px rgba(0, 208, 132, 0.3);
            transform: translateY(-3px) scale(1.02);
        }

        &:active:not(:disabled) {
            transform: translateY(-1px) scale(0.98);
            box-shadow: 0 4px 15px rgba(31, 123, 255, 0.4);
        }

        &:disabled {
            background: linear-gradient(135deg, #cbd5e0 0%, #a0aec0 100%);
            cursor: not-allowed;
            opacity: 0.6;
            box-shadow: none;
            transform: none !important;
        }

        i, span {
            position: relative;
            z-index: 1;
        }

        i {
            font-size: 1.1rem;
            transition: transform 0.3s ease;
        }

        &:hover:not(:disabled) i {
            transform: translateX(3px);
        }
    }

    /* Melhorias nas respostas da IA */
    .tyn-qa-message {
        transition: all 0.3s ease;
        
        &.bg-question {
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
            border-left: 4px solid #1f7bff;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }

        &.bg-response {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            border-left: 4px solid #00d084;
            box-shadow: 0 2px 8px rgba(0, 208, 132, 0.15);
        }
    }

    /* Botões de opções modernos */
    .btn-outline-primary {
        border: 2px solid #1f7bff;
        color: #1f7bff;
        background: transparent;
        border-radius: 12px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Progress bar moderna */
    .progress {
        height: 8px;
        border-radius: 10px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        border-radius: 10px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        background-size: 200% 100%;
        animation: shimmer 2s linear infinite;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
    }

    /* Animações para mensagens de erro */
    .text-danger {
        animation: pulse 2s ease-in-out infinite;
    }

    /* Responsivo */
    @media (max-width: 768px) {
        .chat-input-modern {
            padding: 1rem;
            border-radius: 16px;
            margin-bottom: 1.5rem;
        }

        .form-control-modern {
            padding: 0.875rem 1rem;
            font-size: 0.95rem;
            border-radius: 12px;
        }

        .btn-send-modern {
            width: 100%;
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
            min-width: unset;
        }

        .char-counter {
            font-size: 0.7rem;
            bottom: 6px;
            right: 10px;
        }
    }

    @media (max-width: 576px) {
        .chat-input-modern {
            padding: 0.875rem;
            border-radius: 14px;
        }

        .chat-input-wrapper {
            gap: 0.75rem;
        }

        .form-control-modern {
            padding: 0.75rem 0.875rem;
            font-size: 0.9rem;
            min-height: 70px;
        }

        .btn-send-modern {
            padding: 0.7rem 1.25rem;
            font-size: 0.9rem;
            border-radius: 12px;

            i {
                font-size: 1rem;
            }
        }
    }

    /* Dropdown de ações melhorado */
    .dropdown-menu.acoes {
        border-radius: 12px;
        border: 2px solid rgba(31, 123, 255, 0.15);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        padding: 0.5rem;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);

        .dropdown-item {
            border-radius: 8px;
            padding: 0.65rem 1rem;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin-bottom: 0.25rem;

            &:hover {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                color: white;
                transform: translateX(4px);

                svg {
                    transform: scale(1.1);
                }
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    /* Botão de dropdown melhorado - com ícone e animação */
    .btn-icon.btn-light.dropdown-toggle {
        border-radius: 10px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid #e9ecef;
        background: white;
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        position: relative;
        overflow: hidden;

        svg {
            transition: all 0.3s ease;
            fill: #6c757d;
        }

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(31, 123, 255, 0.1);
            transform: translate(-50%, -50%);
            transition: width 0.4s ease, height 0.4s ease;
        }

        &:hover::before {
            width: 200%;
            height: 200%;
        }

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            transform: scale(1.08) rotate(90deg);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);
            
            svg {
                fill: white !important;
                color: white !important;
            }
        }

        &:active {
            transform: scale(1.02) rotate(90deg);
        }

        &.show {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            transform: rotate(90deg);

            svg {
                fill: white !important;
                color: white !important;
            }
        }
    }

    [data-bs-theme='dark'] .btn-icon.btn-light.dropdown-toggle {
        background: #1e293b;
        border-color: #334155;

        svg {
            fill: #cbd5e1;
        }

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #00d084 100%);
            border-color: transparent;
            
            svg {
                fill: white !important;
            }
        }
    }

    /* Melhorias nos radio buttons */
    .form-check-input {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 50%;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;
        margin-top: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    .form-check-label {
        cursor: pointer;
        transition: color 0.3s ease;
        user-select: none;

        &:hover {
            color: #1f7bff;
        }
    }

    /* ============================================
       DARK THEME - Consulta
       ============================================ */

    [data-bs-theme="dark"] .chat-input-modern {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.25);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), 
                    0 4px 12px rgba(96, 165, 250, 0.2);

        &:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5), 
                        0 6px 16px rgba(96, 165, 250, 0.3);
            border-color: rgba(96, 165, 250, 0.35);
        }

        &:focus-within {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
            border-color: #60a5fa;
            box-shadow: 0 15px 45px rgba(96, 165, 250, 0.3), 
                        0 0 0 4px rgba(96, 165, 250, 0.15);
        }
    }

    [data-bs-theme="dark"] .form-control-modern {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &::placeholder {
            color: #6b7280;
        }

        &:hover:not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
            background: #1a1d29;
        }

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            color: #ffffff;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15),
                        0 4px 12px rgba(96, 165, 250, 0.2);
        }

        &:disabled {
            background: #1a1d29;
            color: #6b7280;
        }
    }

    [data-bs-theme="dark"] .char-counter {
        background: rgba(30, 35, 48, 0.9);
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .form-control-modern:focus ~ .char-counter {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .btn-send-modern {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            box-shadow: 0 10px 30px rgba(59, 130, 246, 0.5),
                        0 0 20px rgba(16, 185, 129, 0.4);
        }

        &:disabled {
            background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-question {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
        border-left-color: #60a5fa;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-response {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%) !important;
        border-left-color: #34d399;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: #3b82f6;
        color: #60a5fa;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            color: white;
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }
    }

    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .form-check-input {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.2);

        &:checked {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-color: #3b82f6;
        }

        &:disabled {
            background: #1a1d29;
        }
    }

    [data-bs-theme="dark"] .form-check-label {
        color: #e5e7eb;

        &:hover {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] .c-pointer {
        color: #60a5fa;

        &:hover {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] .item-fonte {
        background: rgba(59, 130, 246, 0.15);
        border-color: rgba(59, 130, 246, 0.3);
        color: #93c5fd;

        &:hover {
            background: rgba(59, 130, 246, 0.25);
        }
    }

    [data-bs-theme="dark"] .dropdown-menu.acoes {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .dropdown-item {
            color: #e5e7eb;

            &:hover {
                background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
                color: white;
            }
        }
    }

    [data-bs-theme="dark"] .referencias {
        color: #e5e7eb;

        strong {
            color: #f9fafb;
        }

        p {
            color: #e5e7eb;
        }

        a {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] :deep(.form-control) {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &:hover:not(:focus) {
            background: #1a1d29;
        }

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            color: #ffffff;
        }
    }

    [data-bs-theme="dark"] :deep(.btn-primary) {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message p,
    [data-bs-theme="dark"] .tyn-qa-message strong {
        color: inherit;
    }
</style>

